import { render, staticRenderFns } from "./TouchpointCampaign.vue?vue&type=template&id=37bd0ad1&"
import script from "./TouchpointCampaign.vue?vue&type=script&lang=js&"
export * from "./TouchpointCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bd0ad1')) {
      api.createRecord('37bd0ad1', component.options)
    } else {
      api.reload('37bd0ad1', component.options)
    }
    module.hot.accept("./TouchpointCampaign.vue?vue&type=template&id=37bd0ad1&", function () {
      api.rerender('37bd0ad1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Touchpoint/TouchpointCampaign.vue"
export default component.exports